import React, { useEffect } from 'react';
import AboutMeSome from '../components/home/AboutMeSome';
import Header from '../components/home/Header';
import Projects from '../components/home/Projects';
import Skills from '../components/home/Skills';
import ServicePage from './ServicePage';
import { useLocation } from 'react-router-dom';

const Home = () => {
    
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
    return (
        <div>
            <Header/>
            <AboutMeSome/>
            <ServicePage/>
            <Projects/>
            <Skills/>
        </div>
    );
};

export default Home;